var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useRef, useEffect } from 'react';
import { useParams } from 'react-router-dom';
export default function MobilePhotoCapture() {
    var _this = this;
    var slug = useParams().slug;
    var _a = useState([]), photos = _a[0], setPhotos = _a[1];
    var _b = useState(false), showForm = _b[0], setShowForm = _b[1];
    var _c = useState(false), isUploading = _c[0], setIsUploading = _c[1];
    var _d = useState(false), isUploaded = _d[0], setIsUploaded = _d[1];
    var _e = useState({
        slug: slug,
        file: null,
        block: { id: '', slug: '', title: '', metas: { prompt: '', description: '', logo: '' }, status: 1, created_at: '', modified_at: '' },
    }), data = _e[0], setData = _e[1];
    // Camera State
    var _f = useState(false), showCamera = _f[0], setShowCamera = _f[1];
    var _g = useState(null), cameraError = _g[0], setCameraError = _g[1];
    var videoRef = useRef(null);
    var canvasRef = useRef(null);
    var streamRef = useRef(null);
    var _h = useState({
        address: '',
        notes: '',
        moveDate: '',
        isFlexible: false,
        flexibleDuration: '1_week',
    }), formData = _h[0], setFormData = _h[1];
    // Get today's date in YYYY-MM-DD format for the min attribute
    var today = new Date().toISOString().split('T')[0];
    useEffect(function () {
        prepareUpload(data.slug);
    }, []);
    var prepareUpload = function (slug) { return __awaiter(_this, void 0, void 0, function () {
        var response, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch(App.api_base + '/devis/' + data.slug, {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'X-Vuedoo-Domain': App.domain,
                            'X-Vuedoo-Access-Key': ''
                        },
                    })];
                case 1:
                    response = _a.sent();
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    return [4 /*yield*/, response.json()];
                case 2:
                    res = _a.sent();
                    if (res.status === 'success') {
                        setData(function (prevData) { return (__assign(__assign({}, prevData), { block: res.devis })); });
                        setIsUploaded(res.devis.status === 2); // If status is 2, mark as uploaded
                    }
                    else {
                        window.location.href = '/NotFound';
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    // Cleanup object URLs to prevent memory leaks
    useEffect(function () {
        return function () {
            photos.forEach(function (photo) { return URL.revokeObjectURL(photo.preview); });
            stopCamera();
        };
    }, [photos]);
    // Handle Camera Stream Lifecycle
    useEffect(function () {
        if (showCamera) {
            startCamera();
        }
        else {
            stopCamera();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showCamera]);
    var startCamera = function () { return __awaiter(_this, void 0, void 0, function () {
        var stream, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setCameraError(null);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, navigator.mediaDevices.getUserMedia({
                            video: { facingMode: 'environment' }, // Forces rear camera on mobile
                            audio: false,
                        })];
                case 2:
                    stream = _a.sent();
                    streamRef.current = stream;
                    if (videoRef.current) {
                        videoRef.current.srcObject = stream;
                    }
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _a.sent();
                    console.error('Camera access denied or not supported:', err_1);
                    setCameraError('Unable to access camera. Please ensure you have granted camera permissions.');
                    setShowCamera(false);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var stopCamera = function () {
        if (streamRef.current) {
            streamRef.current.getTracks().forEach(function (track) { return track.stop(); });
            streamRef.current = null;
        }
        if (videoRef.current) {
            videoRef.current.srcObject = null;
        }
    };
    var capturePhoto = function () {
        if (videoRef.current && canvasRef.current) {
            var video = videoRef.current;
            var canvas = canvasRef.current;
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            var context = canvas.getContext('2d');
            if (context) {
                context.drawImage(video, 0, 0, canvas.width, canvas.height);
                canvas.toBlob(function (blob) {
                    if (blob) {
                        var file_1 = new File([blob], "capture_".concat(Date.now(), ".jpg"), { type: 'image/jpeg' });
                        var preview_1 = URL.createObjectURL(file_1);
                        setPhotos(function (prev) { return __spreadArray(__spreadArray([], prev, true), [{ file: file_1, preview: preview_1 }], false); });
                        setShowCamera(false);
                    }
                }, 'image/jpeg', 0.85);
            }
        }
    };
    var handleRemovePhoto = function (indexToRemove) {
        setPhotos(function (prev) {
            var newPhotos = __spreadArray([], prev, true);
            var removed = newPhotos.splice(indexToRemove, 1);
            if (removed[0]) {
                URL.revokeObjectURL(removed[0].preview);
            }
            return newPhotos;
        });
    };
    var handleFinish = function () {
        if (photos.length === 0) {
            alert('Please take at least one photo before finishing.');
            return;
        }
        setShowForm(true);
    };
    var handleSave = function (e) { return __awaiter(_this, void 0, void 0, function () {
        var payload, response, result, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    e.preventDefault();
                    if (photos.length === 0) {
                        alert('Please add at least one photo before submitting.');
                        return [2 /*return*/];
                    }
                    if (!formData.moveDate) {
                        alert('Please select your preferred move date before submitting.');
                        return [2 /*return*/];
                    }
                    setIsUploading(true);
                    payload = new FormData();
                    payload.append('address', formData.address);
                    payload.append('moveDate', formData.moveDate);
                    payload.append('isFlexible', formData.isFlexible.toString());
                    payload.append('flexibleDuration', formData.isFlexible ? formData.flexibleDuration : 'none');
                    payload.append('notes', formData.notes);
                    payload.append('slug', data.slug || '');
                    photos.forEach(function (photo) {
                        payload.append('photos[]', photo.file);
                    });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, 5, 6]);
                    return [4 /*yield*/, fetch(App.api_base + '/devis/' + data.slug + '/upload', {
                            method: 'POST',
                            headers: {
                                'X-Vuedoo-Domain': App.domain,
                                'X-Vuedoo-Access-Key': ''
                            },
                            body: payload,
                        })];
                case 2:
                    response = _a.sent();
                    if (!response.ok) {
                        throw new Error('Upload request failed');
                    }
                    return [4 /*yield*/, response.json()];
                case 3:
                    result = _a.sent();
                    if (result.status && result.status !== 'success') {
                        throw new Error(result.message || 'Upload failed');
                    }
                    setIsUploaded(true); // Mark as uploaded to prevent further edits
                    // Reset state
                    photos.forEach(function (p) { return URL.revokeObjectURL(p.preview); });
                    setPhotos([]);
                    setShowForm(false);
                    setFormData({ address: '', moveDate: '', isFlexible: false, flexibleDuration: '1_week', notes: '' });
                    return [3 /*break*/, 6];
                case 4:
                    error_1 = _a.sent();
                    console.error('Upload error:', error_1);
                    alert('Failed to upload. Please try again.');
                    return [3 /*break*/, 6];
                case 5:
                    setIsUploading(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs("div", { className: "container py-4", style: { maxWidth: '500px' }, children: [isUploaded &&
                (_jsxs("div", { className: "alert alert-warning text-center", role: "alert", children: [_jsx("strong", { children: "We've received your request!" }), " Our team will review your submission and ", _jsx("strong", { children: "email" }), " you with a quote very soon. Just a heads-up: you won't be able to upload more photos or make edits at this point. Thanks for trusting us with your project!"] })), !isUploaded && (_jsx(_Fragment, { children: showCamera ? (_jsx("div", { className: "position-fixed top-0 start-0 w-100 h-100 bg-black d-flex flex-column z-3", children: cameraError ? (_jsxs("div", { className: "d-flex flex-column align-items-center justify-content-center h-100 text-white p-4 text-center", children: [_jsx("p", { className: "mb-3", children: cameraError }), _jsx("button", { className: "btn btn-primary", onClick: function () { return setShowCamera(false); }, children: "Go Back" })] })) : (_jsxs(_Fragment, { children: [_jsx("canvas", { ref: canvasRef, className: "d-none" }), _jsx("video", { ref: videoRef, autoPlay: true, playsInline: true, muted: true, className: "w-100 h-100 object-fit-cover", style: { maxHeight: '70vh' } }), _jsxs("div", { className: "d-flex justify-content-between align-items-center p-4 bg-black", children: [_jsx("button", { className: "btn btn-outline-light rounded-circle", style: { width: '50px', height: '50px' }, onClick: function () { return setShowCamera(false); }, children: "\u2715" }), _jsx("button", { className: "btn btn-light rounded-circle border border-4 border-secondary", style: { width: '70px', height: '70px' }, onClick: capturePhoto, children: _jsx("div", { className: "bg-dark rounded-circle", style: { width: '55px', height: '55px' } }) }), _jsx("div", { style: { width: '50px' } })] })] })) })) : (
                /* ================= MAIN GALLERY & FORM VIEW ================= */
                _jsxs(_Fragment, { children: [_jsx("h4", { className: "text-center mb-4 fw-bold text-primary", children: showForm ? 'Finalize Your Quote' : 'Capture Your Items' }), !showForm ? (_jsxs(_Fragment, { children: [_jsxs("div", { className: "alert alert-primary d-flex align-items-start mb-4", role: "alert", children: [_jsx("span", { className: "fs-4 me-2", children: "\uD83D\uDCF8" }), _jsxs("div", { children: [_jsx("strong", { children: "Photo Instructions:" }), _jsxs("p", { className: "mb-0 small", children: ["Please capture your furniture ensuring that a ", _jsx("strong", { children: "little bit of the ceiling and floor is visible" }), " in the frame. This helps us analyze dimensions for an accurate quote."] })] })] }), _jsxs("div", { className: "row row-cols-3 g-2 mb-4", children: [photos.map(function (photo, index) { return (_jsxs("div", { className: "col position-relative", children: [_jsx("img", { src: photo.preview, alt: "Capture ".concat(index + 1), className: "img-thumbnail w-100 object-fit-cover", style: { height: '100px', aspectRatio: '1/1' } }), _jsx("span", { className: "position-absolute bottom-0 start-0 bg-dark bg-opacity-75 text-white px-2 py-1 rounded-end", style: { fontSize: '10px', fontWeight: 'bold' }, children: index + 1 }), _jsx("button", { onClick: function () { return handleRemovePhoto(index); }, className: "position-absolute top-0 end-0 btn btn-sm btn-danger rounded-circle d-flex align-items-center justify-content-center", style: { width: '24px', height: '24px', padding: 0, margin: '4px' }, title: "Remove photo", children: "\u00D7" })] }, index)); }), _jsx("div", { className: "col", children: _jsxs("button", { onClick: function () { return setShowCamera(true); }, className: "btn btn-outline-primary w-100 h-100 d-flex flex-column align-items-center justify-content-center", style: { height: '100px', aspectRatio: '1/1', borderStyle: 'dashed', borderWidth: '2px' }, children: [_jsx("span", { style: { fontSize: '28px' }, children: "\uD83D\uDCF7" }), _jsx("span", { className: "small fw-bold mt-1", children: "Open Camera" })] }) })] }), photos.length === 0 && (_jsx("p", { className: "text-center text-muted small mb-4", children: "Tap \"Open Camera\" to start capturing your items directly." })), _jsxs("div", { className: "d-grid gap-2 mt-auto", children: [photos.length > 0 && (_jsxs("div", { className: "row g-2", children: [_jsx("div", { className: "col-6", children: _jsx("button", { onClick: function () {
                                                            handleRemovePhoto(photos.length - 1);
                                                            setShowCamera(true);
                                                        }, className: "btn btn-secondary w-100", children: "\u21BA Retake Last" }) }), _jsx("div", { className: "col-6", children: _jsx("button", { onClick: function () { return setShowCamera(true); }, className: "btn btn-primary w-100", children: "+ Take Another" }) })] })), _jsx("button", { onClick: handleFinish, disabled: photos.length === 0, className: "btn btn-success btn-lg mt-2 fw-bold", children: "\u2713 Finish & Get Quote" })] })] })) : (
                        /* ================= FINAL FORM STATE ================= */
                        _jsxs("form", { onSubmit: handleSave, children: [_jsxs("div", { className: "mb-4", children: [_jsxs("label", { className: "form-label text-muted small text-uppercase fw-bold", children: ["Captured Photos (", photos.length, ")"] }), _jsx("div", { className: "d-flex gap-2 overflow-auto pb-2", children: photos.map(function (photo, idx) { return (_jsx("img", { src: photo.preview, alt: "Preview ".concat(idx + 1), className: "img-thumbnail flex-shrink-0", style: { width: '80px', height: '80px', objectFit: 'cover' } }, idx)); }) })] }), _jsxs("div", { className: "mb-3", children: [_jsx("label", { htmlFor: "address", className: "form-label fw-semibold", children: "Moving Address" }), _jsx("input", { type: "text", id: "address", className: "form-control", required: true, value: formData.address, onChange: function (e) { return setFormData(__assign(__assign({}, formData), { address: e.target.value })); }, placeholder: "123 Main St, City, State, ZIP" })] }), _jsxs("div", { className: "mb-3", children: [_jsx("label", { htmlFor: "moveDate", className: "form-label fw-semibold", children: "Preferred Move Date" }), _jsx("input", { type: "date", id: "moveDate", className: "form-control", required: true, min: today, value: formData.moveDate, onChange: function (e) { return setFormData(__assign(__assign({}, formData), { moveDate: e.target.value })); } })] }), _jsx("div", { className: "mb-3", children: _jsxs("div", { className: "form-check", children: [_jsx("input", { className: "form-check-input", type: "checkbox", id: "isFlexible", checked: formData.isFlexible, onChange: function (e) { return setFormData(__assign(__assign({}, formData), { isFlexible: e.target.checked })); } }), _jsx("label", { className: "form-check-label fw-semibold", htmlFor: "isFlexible", children: "My move date is flexible" })] }) }), _jsxs("div", { className: "mb-4", children: [_jsx("label", { htmlFor: "flexibleDuration", className: "form-label fw-semibold ".concat(!formData.isFlexible ? 'text-muted' : ''), children: "Flexibility Window" }), _jsxs("select", { id: "flexibleDuration", className: "form-select", disabled: !formData.isFlexible, value: formData.flexibleDuration, onChange: function (e) { return setFormData(__assign(__assign({}, formData), { flexibleDuration: e.target.value })); }, children: [_jsx("option", { value: "1_day", children: "1 day" }), _jsx("option", { value: "2_days", children: "2 days" }), _jsx("option", { value: "1_week", children: "1 week" }), _jsx("option", { value: "2_weeks", children: "2 weeks" }), _jsx("option", { value: "1_month", children: "1 month" })] }), !formData.isFlexible && (_jsx("div", { className: "form-text text-muted", children: "Check the box above to specify a flexibility window." }))] }), _jsxs("div", { className: "mb-3", children: [_jsx("label", { htmlFor: "notes", className: "form-label fw-semibold", children: "Notes" }), _jsx("input", { type: "text", id: "notes", className: "form-control", value: formData.notes, onChange: function (e) { return setFormData(__assign(__assign({}, formData), { notes: e.target.value })); }, placeholder: "Add any additional notes about your move, i.e. parking restrictions, narrow stairs, etc." })] }), _jsxs("div", { className: "d-grid gap-2", children: [_jsx("button", { type: "button", onClick: function () { return setShowForm(false); }, className: "btn btn-outline-secondary", children: "\u2190 Back to Photos" }), _jsx("button", { type: "submit", disabled: isUploading, className: "btn btn-primary btn-lg fw-bold", children: isUploading ? (_jsxs(_Fragment, { children: [_jsx("span", { className: "spinner-border spinner-border-sm me-2", role: "status", "aria-hidden": "true" }), "Submitting..."] })) : ('Save & Submit Quote') })] })] }))] })) }))] }));
}
